import { render, staticRenderFns } from "./paidDetail.vue?vue&type=template&id=e5db2496&scoped=true"
import script from "./paidDetail.vue?vue&type=script&lang=ts"
export * from "./paidDetail.vue?vue&type=script&lang=ts"
import style0 from "./paidDetail.vue?vue&type=style&index=0&id=e5db2496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5db2496",
  null
  
)

export default component.exports